import type { CalendarItemPayload } from '../schema';
import { getUserMailboxInfo } from 'owa-client-ids';
import { lazyPopoutCalendarReadingPane } from 'owa-popout-calendar';

export default function popoutCalendarItem(payload: CalendarItemPayload) {
    lazyPopoutCalendarReadingPane.importAndExecute(
        {
            Id: payload.itemId,
            mailboxInfo: getUserMailboxInfo(),
        },
        'Spaces'
    );
}
